import { render, staticRenderFns } from "./ProcessedRepairManage.vue?vue&type=template&id=0a33fcba&scoped=true"
import script from "./ProcessedRepairManage.vue?vue&type=script&lang=js"
export * from "./ProcessedRepairManage.vue?vue&type=script&lang=js"
import style0 from "./ProcessedRepairManage.vue?vue&type=style&index=0&id=0a33fcba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33fcba",
  null
  
)

export default component.exports